<div class="ucc-selection-container">
    <span *ngIf="!isSislWealth" class="heading-line margin-bottom">Here are the client codes linked to your registered<br> mobile number <span
            class="font-bold">(+91 ******{{ phoneNumber }}) </span> <a (click)="changeNumber()" disabled
            class="change-link color-link margin-4-left font-12">Change</a></span>
    <mat-radio-group class="dense-radio-button client-code-list" [(ngModel)]="uccSelection">
        <mat-radio-button class="client-code-item border flex-space-between" *ngFor="let code of uccData" [value]="code.ucc">
            <span>{{ code.ucc }}</span>
            <span class="username-text margin-8-left">{{ code.name }}</span>
        </mat-radio-button>
    </mat-radio-group>
    <button mat-flat-button color="accent" type="submit" class="submit select-button full-width" (click)="submitUcc()"
        cdkFocusInitial>Select Account</button>
</div>